import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { flattenDeep } from "lodash";
import { Button, Grid } from "@material-ui/core";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";
import { getImage } from "actions/taskDetail/taskDetailActions";
import { showImagesList } from "actions/chat/chat";
import Collapse from "./Collapse";

const ImageVideo = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const project = useSelector(
    (state) => state.project.detailProject.data.project
  );
  const taskId = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.id
  );
  const totalImg = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.total_img
  );
  const images = useCacheDataMainTask("taskDetail.media.detailImage", []);

  useEffect(() => {
    if (taskId && taskId === project?.main_task) {
      dispatch(getImage({ taskId }));
    }
  }, [dispatch, taskId, totalImg, project]);

  const handleClickImage = (idx) => {
    dispatch(
      showImagesList(
        true,
        flattenDeep(images.map((item) => item.images))
          .reverse()
          .slice(0, 8),
        idx
      )
    );
  };

  return (
    <Collapse
      classes="listPartTabBody--media listPartTabBody--images"
      label={t("LABEL_CHAT_TASK_PHOTO_VIDEO")}
    >
      {images.length > 0 ? (
        <div>
          <Grid
            container
            spacing={1}
            className="listPartTabBody--images--container"
          >
            {flattenDeep(images.map((item) => item.images))
              .reverse()
              .slice(0, 8)
              .map((item, idx) => (
                <Grid
                  item
                  xs={3}
                  key={item.id}
                  onClick={() => handleClickImage(idx)}
                >
                  <div
                    className="listPartTabBody--images--item"
                    style={{ backgroundImage: `url(${item.url_thumbnail})` }}
                  />
                </Grid>
              ))}
          </Grid>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              props.setDefaultMediaTab(0);
              props.setShow(4);
            }}
          >
            {t("LABEL_CHAT_TASK_BTN_VIEW_ALL")}
          </Button>
        </div>
      ) : (
        <>
          <div className="listPartTabBody--msg_empty_data">
            {t("LABEL_CHAT_TASK_EMPTY_PHOTO")}
          </div>
          <Button
            fullWidth
            variant="contained"
            onClick={() => document.getElementById("upload_image").click()}
          >
            {t("LABEL_CHAT_TASK_BTN_ADD_PHOTO")}
          </Button>
        </>
      )}
    </Collapse>
  );
};

export default ImageVideo;
